/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field__Enum_Teachingsubjectinterest_Subject_English16Inputs */

const en__field__enum_teachingsubjectinterest_subject_english16 = /** @type {(inputs: _Field__Enum_Teachingsubjectinterest_Subject_English16Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`English`)
};

const de__field__enum_teachingsubjectinterest_subject_english16 = /** @type {(inputs: _Field__Enum_Teachingsubjectinterest_Subject_English16Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Englisch`)
};

/**
* | output |
* | --- |
* | "English" |
*
* @param {_Field__Enum_Teachingsubjectinterest_Subject_English16Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field__enum_teachingsubjectinterest_subject_english16 = /** @type {((inputs?: _Field__Enum_Teachingsubjectinterest_Subject_English16Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field__Enum_Teachingsubjectinterest_Subject_English16Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field__enum_teachingsubjectinterest_subject_english16(inputs)
	return de__field__enum_teachingsubjectinterest_subject_english16(inputs)
});
export { _field__enum_teachingsubjectinterest_subject_english16 as "_field__enum_teachingSubjectInterest_SUBJECT_ENGLISH" }